/* eslint-disable */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "didomiSDK", {
    enumerable: true,
    get: function() {
        return didomiSDK;
    }
});
var didomiSDK = function didomiSDK(id) {
    ;
    (function(e, r) {
        ////////////////////////////////////////////////
        // Lines below are NOT part of the original SDK code
        // This is a workaround to prevent the SDK from loading multiple times
        if (!!document.querySelector("#spcloader")) {
            // For debugging purposes only
            window.didomiSdkAlreadyPresent = true;
            return;
        }
        ////////////////////////////////////////////////
        var t = document.createElement("link");
        t.rel = "preconnect";
        t.as = "script";
        var n = document.createElement("link");
        n.rel = "dns-prefetch";
        n.as = "script";
        var i = document.createElement("script");
        i.id = "spcloader";
        i.type = "text/javascript";
        i["async"] = true;
        i.charset = "utf-8";
        var o = "https://sdk.privacy-center.org/" + e + "/loader.js?target_type=notice&target=" + r;
        if (window.didomiConfig && window.didomiConfig.user) {
            var a = window.didomiConfig.user;
            var c = a.country;
            var d = a.region;
            if (c) {
                o = o + "&country=" + c;
                if (d) {
                    o = o + "&region=" + d;
                }
            }
        }
        t.href = "https://sdk.privacy-center.org/";
        n.href = "https://sdk.privacy-center.org/";
        i.src = o;
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(t, s);
        s.parentNode.insertBefore(n, s);
        s.parentNode.insertBefore(i, s);
    })(id, "mZjmYLa6");
};

//# sourceMappingURL=sdk.js.map